/* Asiro: adds a small "Help" link list to the bottom of the menu drawer.
   Added client side so the large theme file snippets/header-drawer.liquid stays untouched.
   Links follow the store language root, so they keep working once Dutch is published.
   Styles live in assets/asiro-polish.css. */
(function () {
  var COPY = {
    en: { label: 'Help', shipping: 'Shipping', returns: 'Returns and refunds' },
    nl: { label: 'Hulp', shipping: 'Verzending', returns: 'Retourneren en terugbetalen' }
  };

  function languageRoot() {
    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
    } catch (e) {}
    return '/';
  }

  function makeHelp() {
    var lang = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
    var t = COPY[lang] || COPY.en;
    var root = languageRoot();
    var links = [
      [t.shipping, root + 'policies/shipping-policy'],
      [t.returns, root + 'policies/refund-policy'],
      ['support@asiro.nl', 'mailto:support@asiro.nl']
    ];

    var wrap = document.createElement('div');
    wrap.className = 'asiro-drawer-help';

    var label = document.createElement('span');
    label.className = 'asiro-drawer-help__label';
    label.textContent = t.label;
    wrap.appendChild(label);

    var list = document.createElement('ul');
    list.className = 'asiro-drawer-help__list';
    list.setAttribute('role', 'list');

    for (var i = 0; i < links.length; i++) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = links[i][1];
      link.textContent = links[i][0];
      item.appendChild(link);
      list.appendChild(item);
    }

    wrap.appendChild(list);
    return wrap;
  }

  function addHelp() {
    var hosts = document.querySelectorAll('.menu-drawer__utility-links');
    for (var i = 0; i < hosts.length; i++) {
      if (!hosts[i].querySelector('.asiro-drawer-help')) {
        hosts[i].insertBefore(makeHelp(), hosts[i].firstChild);
      }
    }
  }

  function init() {
    addHelp();
    var headerGroup = document.getElementById('header-group');
    if (headerGroup && 'MutationObserver' in window) {
      new MutationObserver(addHelp).observe(headerGroup, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
